/* JOBECA HOME — interacciones y animaciones del nuevo diseño (vanilla JS) */
(function () {
  'use strict';

  var root = document.documentElement;
  var reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* ---------- entrada de la página ---------- */
  function markLoaded() {
    var delay = root.classList.contains('jb-has-curtain') ? 1150 : 60;
    setTimeout(function () {
      root.classList.add('jb-loaded');
      document.querySelectorAll('.jb-split-words:not([data-jb-reveal])').forEach(function (el) { el.classList.add('is-in'); });
    }, delay);
  }

  /* ---------- títulos que entran palabra a palabra ---------- */
  function splitWords(scope) {
    (scope || document).querySelectorAll('.jb-split-words:not([data-split])').forEach(function (el) {
      el.setAttribute('data-split', '1');
      var i = 0;
      function wrap(node) {
        Array.prototype.slice.call(node.childNodes).forEach(function (child) {
          if (child.nodeType === 3) {
            var frag = document.createDocumentFragment();
            child.textContent.split(/(\s+)/).forEach(function (part) {
              if (!part) return;
              if (/^\s+$/.test(part)) { frag.appendChild(document.createTextNode(' ')); return; }
              var w = document.createElement('span');
              w.className = 'jb-w';
              var inner = document.createElement('span');
              inner.style.setProperty('--i', i++);
              inner.textContent = part;
              w.appendChild(inner);
              frag.appendChild(w);
            });
            node.replaceChild(frag, child);
          } else if (child.nodeType === 1 && child.tagName !== 'BR') {
            wrap(child);
          }
        });
      }
      wrap(el);
      if (root.classList.contains('jb-loaded') && !el.hasAttribute('data-jb-reveal')) el.classList.add('is-in');
    });
  }

  /* ---------- aparición al hacer scroll ---------- */
  var revealObserver = null;
  function initReveals(scope) {
    scope = scope || document;
    scope.querySelectorAll('[data-jb-stagger]').forEach(function (group) {
      var step = parseInt(group.getAttribute('data-jb-stagger'), 10) || 90;
      group.querySelectorAll('[data-jb-reveal]').forEach(function (el, idx) {
        el.style.setProperty('--jb-delay', (idx * step) + 'ms');
      });
    });
    var items = scope.querySelectorAll('[data-jb-reveal]:not(.is-in)');
    if (!('IntersectionObserver' in window) || reduced || !root.classList.contains('jb-anim')) {
      items.forEach(function (el) { el.classList.add('is-in'); });
      return;
    }
    if (!revealObserver) {
      revealObserver = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            entry.target.classList.add('is-in');
            revealObserver.unobserve(entry.target);
          }
        });
      }, { rootMargin: '0px 0px -8% 0px', threshold: 0.12 });
    }
    items.forEach(function (el) { revealObserver.observe(el); });
  }

  /* ---------- parallax suave ---------- */
  var parallaxEls = [];
  var ticking = false;
  function updateParallax() {
    ticking = false;
    var vh = window.innerHeight;
    parallaxEls.forEach(function (el) {
      var rect = el.parentElement.getBoundingClientRect();
      if (rect.bottom < -200 || rect.top > vh + 200) return;
      var speed = parseFloat(el.getAttribute('data-jb-parallax')) || 0.15;
      var progress = (rect.top + rect.height / 2 - vh / 2) / vh;
      el.style.transform = 'translate3d(0,' + (progress * speed * -100).toFixed(2) + 'px,0)';
    });
  }
  function initParallax() {
    if (reduced) return;
    parallaxEls = Array.prototype.slice.call(document.querySelectorAll('[data-jb-parallax]'));
    if (!parallaxEls.length) return;
    updateParallax();
  }
  window.addEventListener('scroll', function () {
    if (!parallaxEls.length || ticking) return;
    ticking = true;
    requestAnimationFrame(updateParallax);
  }, { passive: true });

  /* ---------- carriles deslizables (categorías, vitrina) ---------- */
  function initRails(scope) {
    (scope || document).querySelectorAll('[data-jb-rail]:not([data-ready])').forEach(function (rail) {
      rail.setAttribute('data-ready', '1');
      var wrap = rail.closest('[data-jb-rail-wrap]') || rail.parentElement;
      var prev = wrap.querySelector('[data-jb-prev]');
      var next = wrap.querySelector('[data-jb-next]');
      function stepSize() {
        var card = rail.firstElementChild;
        return card ? card.getBoundingClientRect().width + 20 : rail.clientWidth * 0.8;
      }
      function update() {
        if (prev) prev.disabled = rail.scrollLeft < 8;
        if (next) next.disabled = rail.scrollLeft + rail.clientWidth > rail.scrollWidth - 8;
      }
      if (prev) prev.addEventListener('click', function () { rail.scrollBy({ left: -stepSize(), behavior: 'smooth' }); });
      if (next) next.addEventListener('click', function () { rail.scrollBy({ left: stepSize(), behavior: 'smooth' }); });
      rail.addEventListener('scroll', update, { passive: true });
      window.addEventListener('resize', update);
      update();

      // arrastrar con el ratón
      var down = false, startX = 0, startLeft = 0, moved = false;
      rail.addEventListener('mousedown', function (e) {
        down = true; moved = false; startX = e.pageX; startLeft = rail.scrollLeft;
      });
      window.addEventListener('mousemove', function (e) {
        if (!down) return;
        var dx = e.pageX - startX;
        if (Math.abs(dx) > 5) { moved = true; rail.classList.add('is-dragging'); }
        if (moved) rail.scrollLeft = startLeft - dx;
      });
      window.addEventListener('mouseup', function () {
        if (!down) return;
        down = false;
        setTimeout(function () { rail.classList.remove('is-dragging'); }, 30);
      });
      rail.addEventListener('dragstart', function (e) { e.preventDefault(); });

      // en el móvil el carril no se mueve solo (touch-action: pan-y): deslizar en vertical siempre baja la página
      // y solo se pasan tarjetas cuando el gesto es claramente horizontal
      var tx = 0, ty = 0, tLeft = 0, tTime = 0, eje = null;
      rail.addEventListener('touchstart', function (e) {
        var t = e.touches[0];
        tx = t.clientX; ty = t.clientY; tLeft = rail.scrollLeft; tTime = Date.now(); eje = null;
      }, { passive: true });
      rail.addEventListener('touchmove', function (e) {
        var t = e.touches[0], dx = t.clientX - tx, dy = t.clientY - ty;
        if (!eje && (Math.abs(dx) > 10 || Math.abs(dy) > 10)) {
          eje = Math.abs(dx) > Math.abs(dy) * 1.4 ? 'x' : 'y';
          if (eje === 'x') rail.classList.add('is-dragging');
        }
        if (eje === 'x') rail.scrollLeft = tLeft - dx;
      }, { passive: true });
      rail.addEventListener('touchend', function (e) {
        if (eje !== 'x') return;
        var dx = e.changedTouches[0].clientX - tx;
        var paso = stepSize();
        var rapido = Math.abs(dx) / Math.max(1, Date.now() - tTime) > 0.35;
        var desde = Math.round(tLeft / paso);
        var n = rapido || Math.abs(dx) > paso * 0.25 ? (dx < 0 ? 1 : -1) : 0;
        rail.classList.remove('is-dragging');
        rail.scrollTo({ left: Math.max(0, (desde + n) * paso), behavior: 'smooth' });
      }, { passive: true });
    });
  }

  /* ---------- "Monta tu dormitorio" (pasos con escenario) ---------- */
  function initSteps(scope) {
    (scope || document).querySelectorAll('[data-jb-steps]:not([data-ready])').forEach(function (box) {
      box.setAttribute('data-ready', '1');
      var steps = box.querySelectorAll('.jb-step');
      var slides = box.querySelectorAll('.jb-stage__slide');
      var counter = box.querySelector('.jb-stage__count');
      var label = box.querySelector('.jb-stage__label');
      var ms = parseInt(box.getAttribute('data-autoplay'), 10) || 0;
      var current = 0, timer = null, visible = false;
      box.style.setProperty('--jb-step-ms', ms + 'ms');

      function go(i) {
        current = (i + steps.length) % steps.length;
        steps.forEach(function (s, idx) {
          s.classList.toggle('is-active', idx === current);
          var b = s.querySelector('.jb-step__btn');
          if (b) b.setAttribute('aria-expanded', idx === current ? 'true' : 'false');
          // reinicia la barra de progreso
          var bar = s.querySelector('.jb-step__bar');
          if (bar && idx === current) { bar.style.animation = 'none'; void bar.offsetWidth; bar.style.animation = ''; }
        });
        slides.forEach(function (s, idx) { s.classList.toggle('is-active', idx === current); });
        if (counter) counter.textContent = '0' + (current + 1);
        if (label) label.textContent = steps[current].getAttribute('data-label') || '';
        schedule();
      }
      function schedule() {
        clearTimeout(timer);
        if (ms > 0 && visible && !box.classList.contains('is-paused')) timer = setTimeout(function () { go(current + 1); }, ms);
      }
      steps.forEach(function (s, idx) {
        var b = s.querySelector('.jb-step__btn');
        if (b) b.addEventListener('click', function () { go(idx); });
      });
      box.addEventListener('mouseenter', function () { box.classList.add('is-paused'); clearTimeout(timer); });
      box.addEventListener('mouseleave', function () { box.classList.remove('is-paused'); go(current); });
      if ('IntersectionObserver' in window) {
        new IntersectionObserver(function (entries) {
          visible = entries[0].isIntersecting;
          if (visible) go(current); else clearTimeout(timer);
        }, { threshold: 0.35 }).observe(box);
      }
      go(0);
    });
  }

  /* ---------- galería de producto ---------- */
  function initGallery(scope) {
    (scope || document).querySelectorAll('[data-jb-gallery]:not([data-ready])').forEach(function (g) {
      g.setAttribute('data-ready', '1');
      var track = g.querySelector('.jb-gallery__slides');
      var slides = g.querySelectorAll('.jb-gallery__slide');
      var thumbs = g.querySelectorAll('.jb-gallery__thumb');
      if (!track || !slides.length) return;
      function goTo(i, smooth) {
        i = Math.max(0, Math.min(slides.length - 1, i));
        track.scrollTo({ left: slides[i].offsetLeft, behavior: smooth === false ? 'auto' : 'smooth' });
        setActive(i);
      }
      function setActive(i) {
        thumbs.forEach(function (t, idx) { t.classList.toggle('is-active', idx === i); });
        g.setAttribute('data-index', i);
      }
      function currentIndex() { return Math.round(track.scrollLeft / track.clientWidth); }
      thumbs.forEach(function (t, idx) { t.addEventListener('click', function () { goTo(idx); }); });
      var prev = g.querySelector('[data-jb-prev]');
      var next = g.querySelector('[data-jb-next]');
      if (prev) prev.addEventListener('click', function () { goTo(currentIndex() - 1); });
      if (next) next.addEventListener('click', function () { goTo(currentIndex() + 1); });
      var t;
      track.addEventListener('scroll', function () {
        clearTimeout(t);
        t = setTimeout(function () { setActive(currentIndex()); }, 80);
      }, { passive: true });
      // zoom al pulsar (solo con ratón)
      slides.forEach(function (s) {
        s.addEventListener('click', function (e) {
          if (window.matchMedia('(hover: none)').matches) return;
          var img = s.querySelector('img');
          if (!img) return;
          var r = s.getBoundingClientRect();
          img.style.transformOrigin = ((e.clientX - r.left) / r.width * 100) + '% ' + ((e.clientY - r.top) / r.height * 100) + '%';
          s.classList.toggle('is-zoom');
        });
        s.addEventListener('mousemove', function (e) {
          if (!s.classList.contains('is-zoom')) return;
          var img = s.querySelector('img');
          var r = s.getBoundingClientRect();
          img.style.transformOrigin = ((e.clientX - r.left) / r.width * 100) + '% ' + ((e.clientY - r.top) / r.height * 100) + '%';
        });
        s.addEventListener('mouseleave', function () { s.classList.remove('is-zoom'); });
      });
      g.jbGoToMedia = function (mediaId) {
        slides.forEach(function (s, idx) { if (s.getAttribute('data-media-id') === String(mediaId)) goTo(idx); });
      };
    });
  }

  /* ---------- selector de variantes, cantidad y barra fija ---------- */
  function money(cents, format) {
    var value = (cents / 100).toFixed(2);
    var parts = value.split('.');
    var intPart = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, '.');
    var withDec = intPart + ',' + parts[1];
    var noDec = intPart;
    format = format || '{{amount_with_comma_separator}} €';
    return format
      .replace(/\{\{\s*amount_no_decimals_with_comma_separator\s*\}\}/, noDec)
      .replace(/\{\{\s*amount_with_comma_separator\s*\}\}/, withDec)
      .replace(/\{\{\s*amount_no_decimals\s*\}\}/, parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ','))
      .replace(/\{\{\s*amount\s*\}\}/, parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ',') + '.' + parts[1]);
  }

  function initProduct(scope) {
    (scope || document).querySelectorAll('[data-jb-product]:not([data-ready])').forEach(function (box) {
      box.setAttribute('data-ready', '1');
      var dataEl = box.querySelector('[data-jb-variants]');
      var variants = dataEl ? JSON.parse(dataEl.textContent) : [];
      var moneyFormat = box.getAttribute('data-money-format');
      var idInput = box.querySelector('input[name="id"]');
      var priceNow = box.querySelectorAll('[data-jb-price]');
      var priceWas = box.querySelector('[data-jb-compare]');
      var save = box.querySelector('[data-jb-save]');
      var addBtn = box.querySelector('.jb-buy__add');
      var addLabel = addBtn ? addBtn.querySelector('span') : null;
      var stock = box.querySelector('[data-jb-stock]');
      var selectedLabels = box.querySelectorAll('[data-jb-selected]');
      var gallery = box.querySelector('[data-jb-gallery]');
      var txtAdd = box.getAttribute('data-txt-add');
      var txtSold = box.getAttribute('data-txt-sold');
      var txtIn = box.getAttribute('data-txt-in');
      var txtOut = box.getAttribute('data-txt-out');

      function selectedOptions() {
        var opts = [];
        box.querySelectorAll('[data-jb-option]').forEach(function (fs) {
          var checked = fs.querySelector('input:checked');
          var sel = fs.querySelector('select');
          opts.push(checked ? checked.value : (sel ? sel.value : null));
        });
        return opts;
      }
      function update() {
        var opts = selectedOptions();
        var v = variants.find(function (variant) {
          return variant.options.every(function (o, i) { return o === opts[i]; });
        });
        box.querySelectorAll('[data-jb-option]').forEach(function (fs, i) {
          var label = fs.querySelector('[data-jb-selected]');
          if (label) label.textContent = opts[i] || '';
        });
        if (!v) {
          if (addBtn) addBtn.disabled = true;
          if (addLabel) addLabel.textContent = txtSold;
          return;
        }
        if (idInput) { idInput.value = v.id; idInput.dispatchEvent(new Event('change', { bubbles: true })); }
        priceNow.forEach(function (p) { p.textContent = money(v.price, moneyFormat); });
        if (priceWas) {
          var onSale = v.compare_at_price && v.compare_at_price > v.price;
          priceWas.hidden = !onSale;
          if (onSale) priceWas.textContent = money(v.compare_at_price, moneyFormat);
          if (save) {
            save.hidden = !onSale;
            if (onSale) save.textContent = '-' + Math.round((1 - v.price / v.compare_at_price) * 100) + '%';
          }
        }
        if (addBtn) addBtn.disabled = !v.available;
        if (addLabel) addLabel.textContent = v.available ? txtAdd : txtSold;
        if (stock) {
          stock.classList.toggle('is-out', !v.available);
          stock.textContent = v.available ? txtIn : txtOut;
        }
        if (gallery && v.featured_media && gallery.jbGoToMedia) gallery.jbGoToMedia(v.featured_media.id);
        var sticky = document.querySelector('[data-jb-sticky-price]');
        if (sticky) sticky.textContent = money(v.price, moneyFormat);
        if (window.history && window.history.replaceState) {
          var url = new URL(window.location.href);
          url.searchParams.set('variant', v.id);
          window.history.replaceState({}, '', url.toString());
        }
      }
      // si la combinación elegida no existe (p. ej. tapa doble en 80 cm), salta a la más parecida que sí exista
      var fieldsets = box.querySelectorAll('[data-jb-option]');
      function exists(opts) {
        return variants.some(function (v) { return v.options.every(function (o, i) { return o === opts[i]; }); });
      }
      function fixSelection(changedIdx) {
        var opts = selectedOptions();
        if (exists(opts)) return;
        var best = null, bestScore = -1;
        variants.forEach(function (v) {
          if (v.options[changedIdx] !== opts[changedIdx]) return;
          var score = v.options.filter(function (o, i) { return o === opts[i]; }).length;
          if (score > bestScore) { best = v; bestScore = score; }
        });
        if (!best) return;
        fieldsets.forEach(function (fs, i) {
          var sel = fs.querySelector('select');
          if (sel) { sel.value = best.options[i]; return; }
          fs.querySelectorAll('input').forEach(function (inp) { inp.checked = inp.value === best.options[i]; });
        });
      }
      // atenúa los valores que no existen para la primera opción elegida (p. ej. anchos sin tapa doble)
      function markMissing() {
        var first = selectedOptions()[0];
        fieldsets.forEach(function (fs, i) {
          if (i === 0) return;
          fs.querySelectorAll('.jb-opt__pill').forEach(function (pill) {
            var val = pill.querySelector('input').value;
            var ok = variants.some(function (v) { return v.options[0] === first && v.options[i] === val; });
            pill.classList.toggle('is-missing', !ok);
          });
        });
      }
      fieldsets.forEach(function (fs, i) {
        fs.querySelectorAll('input, select').forEach(function (inp) {
          inp.addEventListener('change', function () { fixSelection(i); update(); markMissing(); });
        });
      });
      if (selectedLabels.length) { update(); markMissing(); }

      // cantidad
      box.querySelectorAll('[data-jb-qty]').forEach(function (q) {
        var input = q.querySelector('input');
        q.querySelectorAll('button').forEach(function (b) {
          b.addEventListener('click', function () {
            var val = parseInt(input.value, 10) || 1;
            val += b.getAttribute('data-step') === '-1' ? -1 : 1;
            input.value = Math.max(1, val);
          });
        });
      });

      // barra de compra fija en móvil
      var bar = document.querySelector('[data-jb-sticky-buy]');
      if (bar && addBtn && 'IntersectionObserver' in window) {
        new IntersectionObserver(function (entries) {
          var e = entries[0];
          bar.classList.toggle('is-shown', !e.isIntersecting && e.boundingClientRect.top < 0);
        }).observe(addBtn);
        var barBtn = bar.querySelector('button');
        if (barBtn) barBtn.addEventListener('click', function () {
          if (!addBtn.disabled) addBtn.click();
          else addBtn.scrollIntoView({ behavior: 'smooth', block: 'center' });
        });
      }
    });
  }

  /* ---------- arranque ---------- */
  function initAll(scope) {
    splitWords(scope);
    initReveals(scope);
    initRails(scope);
    initSteps(scope);
    initGallery(scope);
    initProduct(scope);
    initParallax();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { initAll(); markLoaded(); });
  } else { initAll(); markLoaded(); }

  // editor de Shopify: re-iniciar al editar una sección
  document.addEventListener('shopify:section:load', function (e) {
    initAll(e.target);
    root.classList.add('jb-loaded');
    e.target.querySelectorAll('.jb-split-words').forEach(function (el) { el.classList.add('is-in'); });
    e.target.querySelectorAll('[data-jb-reveal]').forEach(function (el) { el.classList.add('is-in'); });
  });
})();
